var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRetireplus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003865",
    fillRule: "evenodd",
    d: "M8 3v1.986l4 .001V3h3v1.987h3v10.08a1.93 1.93 0 0 1-1.795 1.914l-.152.005L2 16.985V6.906c0-1.012.793-1.838 1.795-1.914l.152-.006H5V3h3Zm9 7H3l-.001 5.984 13.054.002a.937.937 0 0 0 .94-.813l.007-.106V10Zm-4.337.602.724.69-3.366 3.526-2.368-2.279.694-.72L9.99 13.4l2.672-2.799ZM5 5.986H3.947a.938.938 0 0 0-.94.813L3 6.906V9h14V5.987h-2V8h-3V5.987l-4-.001V8H5V5.986ZM7 4H6v3h1V4Zm7 0h-1v3h1V4Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRetireplus);
export default ForwardRef;